import React from 'react';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import {
  Assignment as AssignmentIcon,
  Computer as ComputerIcon,
  Domain as DomainIcon,
  Key as KeyIcon,
  Security as SecurityIcon,
} from '@mui/icons-material';

const ASSET_TYPE_OPTIONS = [
  {
    key: 'physical',
    title: 'Ativo Físico',
    description: 'Equipamentos e dispositivos físicos.',
    icon: <ComputerIcon fontSize="small" />,
    color: 'primary.main',
  },
  {
    key: 'token',
    title: 'Token',
    description: 'Gestão de tokens, credenciais e contexto de API.',
    icon: <KeyIcon fontSize="small" />,
    color: 'secondary.main',
  },
  {
    key: 'domain',
    title: 'Domínio',
    description: 'Gestão de domínios e validade.',
    icon: <DomainIcon fontSize="small" />,
    color: 'info.main',
  },
  {
    key: 'certificate',
    title: 'Certificado',
    description: 'Gestão de certificados digitais.',
    icon: <SecurityIcon fontSize="small" />,
    color: 'warning.main',
  },
  {
    key: 'license',
    title: 'Licença',
    description: 'Gestão de licenças de software.',
    icon: <AssignmentIcon fontSize="small" />,
    color: 'primary.dark',
  },
];

const AssetTypeSelectorModal = ({ open, onClose, onSelect }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
    <DialogTitle sx={{ pb: 0 }}>
      <Box
        sx={{
          p: 2,
          borderRadius: 2,
          color: 'common.white',
          background: 'linear-gradient(130deg, #1f5eff 0%, #00a387 100%)',
        }}
      >
        <Typography variant="h6">Selecione o tipo de ativo</Typography>
        <Typography variant="body2" sx={{ opacity: 0.92 }}>
          Cada tipo possui formulário específico para cadastro e validação.
        </Typography>
      </Box>
    </DialogTitle>

    <DialogContent dividers>
      <Grid container spacing={1.5}>
        {ASSET_TYPE_OPTIONS.map((option) => (
          <Grid item xs={12} sm={6} md={4} key={option.key}>
            <Card variant="outlined" sx={{ height: '100%' }}>
              <CardActionArea sx={{ height: '100%' }} onClick={() => onSelect(option.key)}>
                <CardContent>
                  <Stack direction="row" spacing={1.2} alignItems="center" sx={{ mb: 1 }}>
                    <Avatar sx={{ bgcolor: option.color, width: 34, height: 34 }}>
                      {option.icon}
                    </Avatar>
                    <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
                      {option.title}
                    </Typography>
                  </Stack>
                  <Typography variant="body2" color="text.secondary">
                    {option.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </DialogContent>

    <DialogActions>
      <Button onClick={onClose}>Cancelar</Button>
    </DialogActions>
  </Dialog>
);

export default AssetTypeSelectorModal;
